/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowFigureASquareDownIcon16Solid = forwardRef('ArrowFigureASquareDownIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M15 4.5A3.5 3.5 0 0 0 11.5 1h-7A3.5 3.5 0 0 0 1 4.5v7A3.5 3.5 0 0 0 4.5 15h7a3.5 3.5 0 0 0 3.5-3.5v-7Zm-3.55 3.445a.75.75 0 0 0-1.058.061L8.75 9.85V4.234a.75.75 0 1 0-1.5 0V9.85L5.608 8.006a.75.75 0 1 0-1.12.998l2.205 2.476a1.75 1.75 0 0 0 2.614 0l2.205-2.476a.75.75 0 0 0-.061-1.059Z" })));
});
